import { defineComponent as _defineComponent } from 'vue'
import { PopoverTriggers, Position, TooltipPlacement } from '@sh/types';
import { ref } from 'vue';

interface Props {
  target: string;
  placement?: TooltipPlacement;
  header?: string;
  triggers?: PopoverTriggers[];
  customClass?: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CcPopover.ts',
  props: {
    target: null,
    placement: { default: Position.RIGHT },
    header: { default: '' },
    triggers: { default: () => [PopoverTriggers.CLICK, PopoverTriggers.BLUR] },
    customClass: null
  },
  setup(__props: any) {



const show = ref(false);

return { __sfc: true,show }
}

})